"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var calculateKeyInsights_1 = require("utils/calculateKeyInsights");
var single_1 = require("utils/selectors/single");
var KeyInsightsForm_1 = __importDefault(require("./KeyInsightsForm"));
var KeyInsightsItem_1 = __importDefault(require("./KeyInsightsItem"));
var PREFIX = 'KeyInsightsPanel';
var classes = {
    buttonWrapper: "".concat(PREFIX, "-buttonWrapper"),
    formWrapper: "".concat(PREFIX, "-formWrapper"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.buttonWrapper)] = {
            marginLeft: theme.spacing(4),
        },
        _b[".".concat(classes.formWrapper)] = {
            '& div': {
                width: '100%',
                border: 0,
                padding: 0,
            },
        },
        _b);
});
var KeyInsightsPanel = function (_a) {
    var _b;
    var serviceStatWithService = _a.serviceStatWithService, recommendations = _a.recommendations, alwaysClosed = _a.alwaysClosed;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var canEdit = !alwaysClosed && (profile === null || profile === void 0 ? void 0 : profile.isAdmin);
    var _c = __read((0, react_1.useState)(canEdit && !serviceStatWithService.keyInsights), 2), isEditorOpen = _c[0], showKeyInsightsEditor = _c[1];
    if (isEditorOpen) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.formWrapper }, { children: (0, jsx_runtime_1.jsx)(KeyInsightsForm_1.default, { recommendations: recommendations !== null && recommendations !== void 0 ? recommendations : [], serviceStatWithService: serviceStatWithService, closeForm: function () { return showKeyInsightsEditor(false); } }) })));
    }
    var serviceName = ((_b = serviceStatWithService === null || serviceStatWithService === void 0 ? void 0 : serviceStatWithService.service) === null || _b === void 0 ? void 0 : _b.name) || '';
    var keyInsights = (0, calculateKeyInsights_1.getKeyInsightsDataFromReviews)(serviceStatWithService, recommendations !== null && recommendations !== void 0 ? recommendations : [], serviceStatWithService.keyInsights || []);
    if (!canEdit && !(keyInsights === null || keyInsights === void 0 ? void 0 : keyInsights.length)) {
        return null;
    }
    return (((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Hudled Insights" })), canEdit && ((0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: function () { return showKeyInsightsEditor(true); }, className: (0, clsx_1.default)('hov-hide', classes.buttonWrapper) }, { children: "Edit" })))] })), (0, jsx_runtime_1.jsx)("div", { children: keyInsights === null || keyInsights === void 0 ? void 0 : keyInsights.map(function (keyInsightData, idx) { return ((0, jsx_runtime_1.jsx)(KeyInsightsItem_1.default, { order: idx + 1, data: keyInsightData, serviceName: serviceName }, "".concat(keyInsightData.templateName, "-").concat(serviceName))); }) })] })));
};
exports.default = KeyInsightsPanel;
